<template>
  <div class="score">

    <h2>
      <span v-if="supplier.name">「{{supplier.name}}」の評価</span>
    </h2>

    <v-container>
      <v-row>
        <v-col cols="12">
          <v-container>
            <v-row>
              <v-col>
                <p class="subtitle-2">評価対象の項目にチェックを入れて、星を選択して下さい。<br>チェックされていない項目は評価対象とされません。</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col v-for="mp in scores" :key="mp.evaluateItemCd" cols="4">

                <span class="text-caption">{{mp.evaluateItemName}}</span>

                <v-rating
                    v-if="mp.active"
                    v-model="mp.score"
                    background-color="grey lighten-1"
                    color="yellow accent-4"
                    dense
                    half-increments
                ></v-rating>
                <span v-else v-on:click="mp.active = true;">
                <v-rating                    
                    background-color="grey lighten-1"
                    color="grey accent-4"
                    v-model="mp.score"
                    dense
                    half-increments
                    readonly                    
                ></v-rating>
                </span>
               
                <v-checkbox label="評価する" class="my-0" v-model="mp.active"></v-checkbox>

              </v-col>
            </v-row>

          </v-container>
        </v-col>

      </v-row>

      <v-row>
        <v-col>
          <h5>強み</h5>
          <v-textarea v-model="strongPoint" outlined rows="3"></v-textarea>
        </v-col>
        <v-col>
          <h5>弱み</h5>
          <v-textarea v-model="weakPoint" outlined rows="3"></v-textarea>
        </v-col>
      </v-row>

    </v-container>

    <v-container>
      <v-row>
        <div></div>
        <v-spacer></v-spacer>
        <div>
          <v-btn v-on:click="onSaveClick" class="mr-3" color="primary">登録</v-btn>
          <v-btn v-on:click="onCancelClick">キャンセル</v-btn>
        </div>
      </v-row>
    </v-container>

  </div>
</template>
<script>

import ObjectParamSupport from "@/components/ObjectParamSupport";
import BaseView from "@/components/BaseView";
import EvaluateAPI from "@/apis/EvaluateAPI";
import SupplierFeatureAPI from "@/apis/SupplierFeatureAPI";

export default {
  mixins:[BaseView,ObjectParamSupport],
  components: {

  },
  props: {
    sup_cd:{
      type:[String, Number]
    }
  },
  data: () => ({
    isInitialized:false,
    isFetched:false,
    isLoading:false,
    isDownloading:false,

    supplier:{
        name:"",
    },

    scores:[
      {
        evaluateItemCd:"",
        score:0,
        evaluateItemName:"",
        active:false,
      },
    ],

   
    strongPoint:"",
    weakPoint:"",

    condition:{},
    pager:{},
    errors:{},
  }),
  computed: {

  },
  mounted:function() {
    this.setupConditions();
  },
  created:function() {
  },
  watch: {
    '$route':function (to, from) {
      this.setupConditions();
    },
  },
  methods: {
    setupConditions(){
      let p = this.getObjectParam();
      if (p){
        // パラメータの転写
      }

      this.fetchData(true)
    },

    fetchData(needDataFetch){
      let self = this;
      if (!this.isInitialized){
        this.fetchBasicData(function () {
          self.fetchData(needDataFetch)
        });
        return;
      }
      if (needDataFetch){
        this.isLoading = true;

        Promise.resolve()
            .then(data => EvaluateAPI.getEvaluateByUser(this.sup_cd,this.userId))
            .then(data => this.makeDisplayData(data))
            .catch(function(err) {
              console.log(err);
              self.showErrorToast("データの取得に失敗しました。");
            })
            .finally(function(){
              self.isLoading = false;
            });
      }
    },

    fetchBasicData(finishProc){
      this.isInitialized = true;
      if (finishProc){
        finishProc();
      }
    },

    makeDisplayData(data) {

      console.log(data)

      let scores = data.evaluates;

      this.supplier.name = data.supplierName;

      this.scores.splice(0)

      scores.forEach(a => {
        this.scores.push({
          evaluateItemCd:a.evaluateItemCd,
          score:a.score,
          evaluateItemName:this.getEvaluateItemName( a.evaluateItemCd ),
          active:false
        })

      });

    },

    onSaveClick(){
      let self = this

      let evaluates = this.scores.filter(a => a.active)

      let updateData = {
        evaluates:evaluates
      }

      //SupplierFeatureAPI.save(this.sup_cd,this.userId,{
      //  feature_class:"", // S:ストロングポイント W:ウィークポイント
      //  content:"",
      //});

      let updatePromises = [];
      if (evaluates.length > 0){
        updatePromises.push(EvaluateAPI.update(this.sup_cd,this.userId,updateData));
      }
      
      let sp = (this.strongPoint || "").trim();
      if (sp){
        updatePromises.push(SupplierFeatureAPI.save(this.sup_cd,this.userId,{
          featureClass:"S",content:sp
        }));
      }

      let wp = (this.weakPoint || "").trim();
      if (wp){
        updatePromises.push(SupplierFeatureAPI.save(this.sup_cd,this.userId,{
          featureClass:"W",content:wp
        }));
      }

      Promise.resolve()
          .then(a => Promise.all(updatePromises))
          .then(res => {
            self.showMessageToast("更新しました。")
            self.$router.push({ name: 'supplier', params: { sup_cd: this.sup_cd } })
          })
          .catch(function (err) {
            window.logger.error(err)
            self.showErrorToast("データの更新に失敗しました。");
          })
          .finally(() => {

          })

      /*
      Promise.resolve()
          .then(data => EvaluateAPI.update(this.sup_cd,this.userId,updateData))
          .then(res => {
            self.showMessageToast("更新しました。")
            self.$router.push({ name: 'supplier', params: { sup_cd: this.sup_cd } })
          })
          .catch(function (err) {
            window.logger.error(err)
            self.showErrorToast("データの更新に失敗しました。");
          })
          .finally(() => {

          })
      */

    },
    onCancelClick(){
      //<router-link :to="'/supplier/' + sup_cd + '/review'">口コミ投稿</router-link>
      //let url = "/supplier/" + this.sup_cd;
      this.$router.push({ name: 'supplier', params: { sup_cd: this.sup_cd } })
    },

  },

}
</script>